import tabsClasses from "@mui/material/Tabs/tabsClasses";
export const MuiTabsTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                minHeight: "auto",
                [`.${tabsClasses.indicator}`]: {
                    backgroundColor: dt.color.primary.key,
                },
            },
        },
    };
};
